import {Steps} from './steps';
import {IntroStep} from './intro.step';
import {EmailStep} from './email.step';
import {Injectable} from '@angular/core';
import {BasicLoanInfoStep} from './basic-loan-info.step';
import {PanVerificationStep} from './pan-verification.step';
import {PhoneVerificationStep} from './phone-verification.step';
import {PersonalInformationStep} from './personal-information.step';
import {LivelihoodInformationStep} from './livelihood-information.step';
import {BorrowedInfoStep} from './borrowed-info.steps';
import {ResidenceProofStep} from './residence-proof.step';
import {BankDetailStep} from './bank-details.step';
import {UploadDocumentsStep} from './upload-documents.step';
import {BorrowerSummaryStep} from './borrower-summary.step';

@Injectable()
export class LoanApplicationFlowSteps extends Steps {
    constructor(introStep: IntroStep, basicLoanInformationStep: BasicLoanInfoStep, panVerificationStep: PanVerificationStep,
                verificationStep: PhoneVerificationStep, emailStep: EmailStep, personalInformationStep: PersonalInformationStep,
                livelihoodInformationStep: LivelihoodInformationStep, borrowedInfoStep: BorrowedInfoStep,
                residenceProofStep: ResidenceProofStep, bankDetailStep: BankDetailStep,
                uploadDocumentsStep: UploadDocumentsStep, borrowerSummaryStep: BorrowerSummaryStep) {
        super(introStep, basicLoanInformationStep, panVerificationStep, verificationStep, emailStep,
            personalInformationStep, livelihoodInformationStep, borrowedInfoStep, residenceProofStep,
            bankDetailStep, uploadDocumentsStep, borrowerSummaryStep);
    }
}
